import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { useNotificationStore } from '../../store/notificationStore';
import { cn } from '../../utils';

const icons = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
    warning: AlertTriangle,
};

const colors = {
    success: 'bg-emerald-50 text-emerald-900 border-emerald-200',
    error: 'bg-red-50 text-red-900 border-red-200',
    info: 'bg-blue-50 text-blue-900 border-blue-200',
    warning: 'bg-orange-50 text-orange-900 border-orange-200',
};

const iconColors = {
    success: 'text-emerald-600',
    error: 'text-red-600',
    info: 'text-blue-600',
    warning: 'text-orange-600',
};

export function ToastContainer() {
    const { notifications, removeNotification } = useNotificationStore();

    return (
        <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-full max-w-sm pointer-events-none">
            {notifications.map((notification) => {
                const Icon = icons[notification.type];

                return (
                    <div
                        key={notification.id}
                        className={cn(
                            "pointer-events-auto flex items-start gap-3 p-4 rounded-lg border shadow-lg transition-all duration-300 animate-in slide-in-from-right-full",
                            colors[notification.type]
                        )}
                        role="alert"
                    >
                        <Icon className={cn("w-5 h-5 mt-0.5 flex-shrink-0", iconColors[notification.type])} />
                        <div className="flex-1">
                            {notification.title && (
                                <h3 className="font-semibold text-sm mb-1">{notification.title}</h3>
                            )}
                            <p className="text-sm opacity-90">{notification.message}</p>
                        </div>
                        <button
                            onClick={() => removeNotification(notification.id)}
                            className="p-1 hover:bg-black/5 rounded transition-colors"
                        >
                            <X className="w-4 h-4 opacity-60" />
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
